











































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import CloseButton from "@/components/buttons/close-button.vue";
import BSwitch from "../../app/switchs/b-switch.vue";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import { IPhotoFormat } from "@/@types/gallsery/gallery";
import { ICoast } from "@/@types/_shared/coast";
import { ILocale } from "@/@types/locale";

@Component({
  components: { CloseButton, SubmitResetButtonGroop, BSwitch },
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
})
export default class GalleryFormatForm extends Vue {
  @Prop({ type: Object, default: null }) format!: IPhotoFormat;

  activeLocale = this.$store.getters.getLanguages[0];

  get languages(): Array<string> {
    return this.$store.getters.getLanguages;
  }

  names: ILocale = {};
  show = true;

  name = "";
  coast: Array<ICoast> = [];
  coastElement: ICoast = {
    value: 0,
    currency: "",
  };

  get getFormat(): IPhotoFormat {
    return {
      _id: this.format ? this.format._id : undefined,
      name: this.names,
      coast: this.coast,
      show: this.show,
    };
  }

  @Watch("coastElement", { deep: true })
  updateCoast(): void {
    if (!this.coastElement.currency || !this.coastElement.value) return;
    for (const coast of this.coast) {
      if (this.coastElement.currency == coast.currency) {
        coast.currency = this.coastElement.currency;
        coast.value = this.coastElement.value;
        this.coastElement = {
          value: 0,
          currency: "",
        };
        return;
      }
    }

    this.coast.push(this.coastElement);
    this.coastElement = {
      value: 0,
      currency: "",
    };
  }

  @Watch("name")
  entryFolderName(): void {
    this.names[this.activeLocale] = this.name;
  }

  @Watch("activeLocale")
  folderName(): void {
    if (this.names)
      this.name = this.names[this.activeLocale]
        ? this.names[this.activeLocale]
        : "";
    else this.name = "";
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }
    for (let i = 0; i < this.coast.length; i++) {
      if (!this.coast[i].currency || !this.coast[i].value)
        this.coast.splice(i, 1);
    }
    this.$emit("uploadFormat", this.getFormat);
  }

  onReset(): void {
    this.name = "";
    this.names = {};
    this.coast = [];
    this.coastElement = {
      value: 0,
      currency: "",
    };
    this.show = false;
  }

  formationUpdateParams(): void {
    if (!this.format || !this.format._id) return;
    this.names = Object.assign({}, this.format.name);
    this.coast = this.format.coast;
    this.show = this.format.show;
    this.coastElement.value = this.coast[0].value;
    this.coastElement.currency = this.coast[0].currency;
    this.folderName();
  }

  mounted(): void {
    this.formationUpdateParams();
  }
}
